// ======================================================================
// File Name       : EmailEditContainer
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React, { Component } from 'react';
import { Button, Col, Form } from 'react-bootstrap';
import { connect } from 'react-redux';
import { getFormValues, isInvalid, reduxForm } from 'redux-form';
import * as emailActions from '../../actions/EmailAction';
import * as groupActions from '../../actions/GroupAction';
import EmailRegisterEditForm from '../../components/email/EmailRegisterEditForm';
import Header from '../../components/Header';
import ModalConductor from '../../components/modal/ModalConductor';
import { hideLoading, showLoading } from '../../utils/PageUtils';

class EmailEditContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isReservation: false,
      isShowConfirmDlg: false,
    };
    this.onChangeCheckbox = this.onChangeCheckbox.bind(this);
    this.handleAddDestinationUsers = this.handleAddDestinationUsers.bind(this);
    this.openConfirmDialog = this.openConfirmDialog.bind(this);
  }

  componentWillMount() {
    const { match, dispatch } = this.props;
    dispatch(emailActions.fetchGroupStructure());
    dispatch(groupActions.fetchGroupStructure());

    if (!match.params || !match.params.id) {
      this.props.history.goBack();
    }
    dispatch(showLoading());
    dispatch(emailActions.resetInitData());
    dispatch(emailActions.fetchGroupStructure());

    const param = {
      searchInfo: {
        emailSenderIdAuto: parseInt(match.params.id, 10),
      },
    };

    dispatch(emailActions.getDataForEdit(match.params.id))
    .then(() => {
      dispatch(emailActions.getReservedEmailDetailForEdit(param));
    })
    .then(() => {
      dispatch(hideLoading());
    });
  }

  componentWillUnmount() {
    const { dispatch } = this.props;
    dispatch(emailActions.resetInitData());
  }

  onChangeCheckbox(event) {
    this.setState({
      ...this.state,
      isReservation: !this.state.isReservation,
    });
  }

  /**
   * When click 選択 button
   */
  handleAddDestinationUsers() {
    const { dispatch } = this.props;
    dispatch(emailActions.initDataForRegisterDestinationUserDialog());
  }

  /**
   * When open confirm dialog
   */
  openConfirmDialog() {
    this.props.dispatch(emailActions.showReservedEmailConfirmDialog());
  }

  backPage() {
    this.props.history.goBack();
  }

  render() {
    const { formValues } = this.props;
    return (
      <div>
        <Form
          onSubmit={(e) => {
            e.preventDefault();
            this.openConfirmDialog();
          }}
          className='form-horizontal'
        >
          <Header name="予約メールの編集" />
          <p className="margin-top-10">
            {'編集する項目を指定してください'}
          </p>

          <EmailRegisterEditForm
            {...formValues}
            isReservation={formValues && formValues.reservedFlag}
            onChangeCheckbox={this.onChangeCheckbox}
            handleAddDestinationUsers={this.handleAddDestinationUsers}
            showConfirmScreen={this.showConfirmScreen}
          />

          <Form.Group className="margin-top-20 text-center">
            <Col sm={12} className="text-center">
              <Button variant="default" className="margin-10" onClick={this.backPage.bind(this)}>
                キャンセル
              </Button>
              <Button
                variant="primary"
                className="btn-96 margin-10"
                onClick={this.props.handleSubmit(this.openConfirmDialog)}
              >
                OK
              </Button>
            </Col>
          </Form.Group>

          <ModalConductor
            formKey="emailRegisterEditForm"
            history={this.props.history}
            isEdit
          />
        </Form>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { email, reservedEmail } = state;
  const { emailRegisterEditForm } = state.form;
  const { formInitialValues } = reservedEmail;

  const formValues = getFormValues('emailRegisterEditForm')(state);
  const initialValues = {
    ...formInitialValues,
  };

  return {
    emailRegisterEditForm,
    invalid: isInvalid('emailRegisterEditForm')(state),
    formValues,
    initialValues,
    email,
  };
};

export default connect(mapStateToProps)(
  reduxForm({
    form: 'emailRegisterEditForm', // a unique identifier for this form
    touchOnChange: true,
    enableReinitialize: true,
  })(EmailEditContainer),
);
